import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { ArchivalUnitCopy } from 'types';
import LoaderOverlay from 'components/loader/loader-overlay';

const useArchivalUnitDetail = (id: string) =>
  useQuery(['archival-unit-detail', id], () =>
    fetch(`/badatelna/api/archival-unit/public/view/${id}`).then(
      async (r) => (r.json() as unknown) as ArchivalUnitCopy
    )
  );

const ArchivalUnitSwitch = () => {
  const { id } = useParams<{ id: string }>();
  const resp = useArchivalUnitDetail(id);
  const { replace } = useHistory();

  if (resp.isLoading) {
    return <LoaderOverlay />;
  }
  if (resp.isSuccess) {
    const eadId = resp.data?.eadNode?.id ?? '';
    if (eadId) {
      replace(`/pomucky/2/${eadId}/ead`);
    } else {
      const collectionId =
        resp.data?.archivalUnitReference?.archivalCollection?.id;
      if (collectionId) {
        replace(`/fondy/2/${id}`);
      } else replace(`/archivalie/0/${id}`);
    }
  }
  if (resp.isError) {
    replace(`/archivalie/0/${id}`);
  }
  return <LoaderOverlay />;
};

export default ArchivalUnitSwitch;
